import {format} from 'date-fns';
import {CategoryFilterEnum, ExamResultStatus} from 'domain/usecases';
import {makeGetExamResults} from 'main/factories/usecases';
import {GetExamResultsParams} from './types';

export const getExamResults = async ({
	selectedDate,
	cdAtendimento,
	signal,
}: GetExamResultsParams) => {
	const formattedDate = selectedDate ? format(selectedDate, 'MM/yyyy') : undefined;

	const response = await makeGetExamResults().get({
		dt_referencia: formattedDate,
		cdAtendimento,
		signal,
	});

	const statusOrder: Record<ExamResultStatus, number> = {
		[CategoryFilterEnum.WAITING]: 1,
		[CategoryFilterEnum.PENDING]: 2,
		[CategoryFilterEnum.RELEASED]: 3,
	};

	return [...response].sort((a, b) => {
		const statusA = statusOrder[a.dsStatus];
		const statusB = statusOrder[b.dsStatus];

		return statusA - statusB;
	});
};
